import type { ReactElement } from "react";
import { useCallback } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import QuotaTag from "app/pages/sales-intelligence/modules/quota/components/QuotaTag/QuotaTag";

const CREDITS_MANAGEMENT_URL = "https://account.similarweb.com/crm-enrichment";

const DataCreditsChip = (): ReactElement => {
    const handleManageClick = useCallback(() => {
        window.open(CREDITS_MANAGEMENT_URL, "_blank", "noopener,noreferrer");
    }, []);

    const tooltipContent = (
        <Stack
            gap="4px"
            data-automation="saved-search-webhooks-credits-tooltip"
        >
            <Text
                fontVariant="tooltip"
                color={colorsPalettes.bluegrey[100]}
            >
                {translate("si.management.saved-search-webhooks.credits-banner.description")}
            </Text>
            <Text
                as="a"
                cursor="pointer"
                fontVariant="tooltip"
                color={colorsPalettes.blue[300]}
                onClick={handleManageClick}
            >
                {translate("si.management.saved-search-webhooks.credits-banner.manage-link")}
            </Text>
        </Stack>
    );

    return (
        <Tooltip
            placement="top"
            content={tooltipContent}
        >
            <div data-automation="saved-search-webhooks-credits-chip">
                <QuotaTag
                    size="md"
                    type="light"
                    title={translate("si.management.saved-search-webhooks.credits-banner.title")}
                />
            </div>
        </Tooltip>
    );
};

export default DataCreditsChip;
